import { render } from "./AddMealsToPlan.vue?vue&type=template&id=715fe28b&scoped=true"
import script from "./AddMealsToPlan.vue?vue&type=script&lang=js"
export * from "./AddMealsToPlan.vue?vue&type=script&lang=js"

import "./AddMealsToPlan.vue?vue&type=style&index=0&id=715fe28b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715fe28b"]])

export default __exports__